module.exports = __webpack_public_path__ + "static/6305-woodrose-22-8a0780d45a9cf31c0715efc0c4219ad5.jpg";